export default __webpack_public_path__ + "static/media/Obdurate Mace.27d09709.jpg";